import { ComponentStyle, Datetime, errorMessagesSection, faExclamationCircle, FormStyle,
         infoPlaceholderSection, React} from "@/imports-files/components/custom-datetime";
         import { useState } from 'react';

         import MomentUtils from '@date-io/moment';

         import {
           DatePicker,
           TimePicker,
           DateTimePicker,
           MuiPickersUtilsProvider,
         } from '@material-ui/pickers';

export function CustomDateTime(props)
{

      return(

            <div className= {`CustomDatePicker`} >
            <MuiPickersUtilsProvider utils={MomentUtils}>

                <DateTimePicker
                    autoOk
                    ampm             =   {false}
                    variant          =    "inline"
                    className        =   { props.className }
                    initialValue     =   { props.initialValue == "Invalid date" ? ''  : props.initialValue }
                    inputProps       =   { props.inputProps }
                    onChange         =   { props.onChange }
                    ref              =   { props.reference }
                    selected         =   { props.selected }
                    format           =   { props.format }
                    value            =   { props.value ? props.value._d || props.value : null }
                    emptyLabel       =   { props.emptyLabel ? t('placeholder:select:date') : ''}
                    disabled         =   { props.disabled ? props.disabled : false}
                    disablePast      =   { props.disablePast ? props.disablePast : false}
                    minDate          =   { props.minDate ? props.minDate : ''}
                />

                </MuiPickersUtilsProvider>

                {
                        props.inputProps.style != undefined ?  errorMessagesSection( props.name, FormStyle, props.formik)
                                                            :  infoPlaceholderSection( props.infoPlaceholder, FormStyle)
                }
            </div>

    /* < div className= {ComponentStyle.Datetime__Section}>

                    <Datetime   className       =   {  props.className }
                                closeOnSelect   =   { props.closeOnSelect }
                                dateFormat      =   { props.dateFormat }
                                initialValue    =   { props.initialValue == "Invalid date" ? ''  : props.initialValue }
                                inputProps      =   { props.inputProps }
                                inputValue      =   { props.inputValue }
                                isValidDate     =   { props.isValidDate }
                                onChange        =   { props.onChange }
                                ref             =   { props.reference }
                                selected        =   { props.selected }
                                timeFormat      =   { props.timeFormat }
                                value           =   { props.value ? '' : props.value }
                    />
                    {
                        props.inputProps.style != undefined ?  errorMessagesSection( props.name, FormStyle, props.formik)
                                                            :  infoPlaceholderSection( props.infoPlaceholder, FormStyle)
                    }

                </div> */
            )
}
